import React, { useState } from 'react';
import { connect } from 'react-redux';
import Button from '../button/Button';
import { uploadFile } from '../../redux/actions/dokumentenverweis';

interface FileUploadprops {
  referenzId: number | undefined; // z.b. auftrag ID
  uploadFile: (
    filename: string,
    referenzId: number,
    file: any,
    successHandler?: () => void
  ) => void;
  onClickHandler?: () => void;
}

/**
 * FileUpload-Component
 * TODO: Oberflaeche schoen machen. zu verwenden -> <FileUpload kategorie='auftrag' referenzId={props.id} />
 *
 * @returns {JSX.Element} Benutzermanagement-Component
 * @constructor
 */
const FileUpload = (props: FileUploadprops) => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [selectedFile, setSelectedFile] = useState('Datei auswählen');
  const [file, setFile] = useState<File>();

  const onClick = () => {
    const referenzId = props.referenzId;
    const filename = file?.name;
    if (filename && selectedFile && referenzId) {
      props.uploadFile(filename, referenzId, file, props.onClickHandler);
      if (inputRef && inputRef.current) {
        inputRef.current.value = '';
        setSelectedFile('Datei auswählen');
      }
    }
  };

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const file = e.target.files
      ? e.target.files[0]
      : new File(['Error'], 'error.xslx');
    if (file && e.target.files) {
      setSelectedFile(file?.name ?? 'Datei auswählen');
      setFile(e.target.files[0]);
    }
  };

  return (
    <div className={'fileupload-wrapper'}>
      <label className={'fileselectionlabel'}>
        <input
          ref={inputRef}
          type='file'
          name='uploadInput'
          onChange={e => {
            onChangeHandler(e);
          }}
        />
        {selectedFile}
      </label>

      <Button
        disabled={selectedFile === 'Datei auswählen'}
        onClickHandler={onClick}
      >
        <i className='fas fa-plus-circle fa-lg'></i> &nbsp;Datei importieren
      </Button>
    </div>
  );
};

export default connect(null, {
  uploadFile,
})(FileUpload);
